export default "__VITE_ASSET__DPQ7mkcf__"